var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeautyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.436C7 10.6746 9.23858 8.43604 12 8.43604C14.7614 8.43604 17 10.6746 17 13.436V18.436C17 20.3217 17 21.2645 16.4142 21.8502C15.8284 22.436 14.8856 22.436 13 22.436H11C9.11438 22.436 8.17157 22.436 7.58579 21.8502C7 21.2645 7 20.3217 7 18.436L7 13.436Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.43604V7.43604C10 6.49323 10 6.02182 10.2929 5.72893C10.5858 5.43604 11.0572 5.43604 12 5.43604C12.9428 5.43604 13.4142 5.43604 13.7071 5.72893C14 6.02182 14 6.49323 14 7.43604V8.43604",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.43604V2.43604M12 2.43604L10 2.43604M12 2.43604L14.745 2.43604C15.5022 2.43604 16.2315 2.72239 16.7864 3.23765L17 3.43604",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.436L17 13.436",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyIcon);
export default __webpack_public_path__ + "static/media/beauty-icon.4ac944d4aca59214824fe185e4952ccf.svg";
export { ForwardRef as ReactComponent };